import {FORM_BUILDER_EVENT_HANDLER} from "../mixins/form-builder/form-builder-event-handler";
import {FORM_BUILDER_METHODS} from "../mixins/form-builder/form-builder-methods";
import {FORM_BUILDER_MODEL} from "../mixins/form-builder/form-builder-model";
import {STYLE_INJECTION_MIXIN} from "../mixins/style-injection-mixin";


export default [
    FORM_BUILDER_EVENT_HANDLER,
    FORM_BUILDER_METHODS,
    FORM_BUILDER_MODEL,
    STYLE_INJECTION_MIXIN
]